import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const employeesRequest = createAction(types.EMPLOYEES_REQUEST);
export const employeesSuccess = createAction(types.EMPLOYEES_SUCCESS);
export const employeesFailure = createAction(types.EMPLOYEES_FAILURE);

export const createEmployeeRequest = createAction(
  types.CREATE_EMPLOYEE_REQUEST,
);
export const createEmployeeSuccess = createAction(
  types.CREATE_EMPLOYEE_SUCCESS,
);
export const createEmployeeFailure = createAction(
  types.CREATE_EMPLOYEE_FAILURE,
);

export const updateEmployeePasswordRequest = createAction(
  types.UPDATE_EMPLOYEE_PASSWORD_REQUEST,
);
export const updateEmployeePasswordSuccess = createAction(
  types.UPDATE_EMPLOYEE_PASSWORD_SUCCESS,
);
export const updateEmployeePasswordFailure = createAction(
  types.UPDATE_EMPLOYEE_PASSWORD_FAILURE,
);

export const deleteEmployeeRequest = createAction(
  types.DELETE_EMPLOYEE_REQUEST,
);
export const deleteEmployeeSuccess = createAction(
  types.DELETE_EMPLOYEE_SUCCESS,
);
export const deleteEmployeeFailure = createAction(
  types.DELETE_EMPLOYEE_FAILURE,
);

export const resetEmployee = createAction(types.RESET_EMPLOYEE);

export default {
  resetEmployee,
  employeesRequest,
  employeesFailure,
  employeesSuccess,
  createEmployeeRequest,
  createEmployeeSuccess,
  createEmployeeFailure,
  updateEmployeePasswordRequest,
  updateEmployeePasswordSuccess,
  updateEmployeePasswordFailure,
  deleteEmployeeRequest,
  deleteEmployeeSuccess,
  deleteEmployeeFailure,
};
